import { useNavigate } from 'react-router-dom';
import { Box, Table as ChakraTable, Tbody, Td, Tr } from '@chakra-ui/react';

import { ChevronRightIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';
import { TextBold, TextRegular, TextSemiBold } from 'UiKit/typography';
import useGetDailyLog from 'Domain/monitoring/useGetDailyLog';
import Tooltip from 'UiKit/tooltip';

import EmptyDailyLog from 'View/monitoring/component/empty-daily-log';
import getStatusColor from 'View/monitoring/helper/getStatusColor';
import LogDailySkeleton from 'View/monitoring/component/skeleton/log-daily-skeleton';

import styles from './styles.module.css';
import moment from 'moment';

const DailyLog = ({ monitoringStatus, t }) => {
  const navigate = useNavigate();

  const currentDate = moment().format('DD-MM-YYYY');

  const { data, isFetching } = useGetDailyLog(monitoringStatus?.presence?.id);

  return (
    <Condition statement={!isFetching} fallback={<LogDailySkeleton />}>
      <Box className={styles['daily-log__container']}>
        <Box className={styles['daily-log__head']}>
          <TextBold className={styles['table_head--title']}>{t('dailyLogView.title')}</TextBold>
          <Box
            className={styles['daily-log__head--button-other']}
            onClick={() => navigate(`/report/attendance/operator/${currentDate}`)}
            data-testid="daily-log__button--other"
          >
            <TextSemiBold className={styles['daily-log__head--button-text']}>{t('dailyLogView.more')}</TextSemiBold>
            <ChevronRightIcon color="var(--color-info50)" width="12" height="12" />
          </Box>
        </Box>
        <Box className={`${styles['daily-log__wrapper']} ${!data?.length && styles['daily-log__empty-wrapper']}`}>
          <Condition statement={!isFetching && data?.length} fallback={<EmptyDailyLog />}>
            <ChakraTable>
              <Tbody>
                <Iteration
                  items={data}
                  render={(item, index) => {
                    const statusText = item?.notes ?? item?.status;
                    const tooltipText = item?.notes ?? '';
                    const statusColor = getStatusColor(statusText);

                    return (
                      <Tr key={index} className={styles['daily-log__row']} data-testid={`daily-log__row`}>
                        <Td className={styles['daily-log__cell']}>
                          <TextRegular className={styles['daily-log__cell--text']}>{item.time}</TextRegular>
                        </Td>
                        <Td className={styles['daily-log__cell']}>
                          <TextBold className={styles['daily-log__cell--text']}>{item.activity}</TextBold>
                        </Td>
                        <Td className={styles['daily-log__cell']}>
                          <TextRegular className={styles['daily-log__cell--text']}>{item?.duration}</TextRegular>
                        </Td>
                        <Td className={styles['daily-log__cell']} maxWidth="250px">
                          <Tooltip label={tooltipText}>
                            <TextRegular className={styles['daily-log__cell--text']} color={statusColor}>
                              {statusText}
                            </TextRegular>
                          </Tooltip>
                        </Td>
                      </Tr>
                    );
                  }}
                />
              </Tbody>
            </ChakraTable>
          </Condition>
        </Box>
      </Box>
    </Condition>
  );
};

export default DailyLog;
